export default __webpack_public_path__ + "static/media/downRightArrowHover.4ae1ca77.png";